/* eslint-disable radix */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/**
 * 广告上报
 */
import { request } from '../request';
import { AdUtils, getAdUserAgent, safeParseJson } from './ad-utils';
import { AdInfo } from './types/ad';
import { AdCgiExposureData, AdClickReportData, AdReportItem, AdVrReportData, IAdPlayReportData } from './types/ad-report';
import { AdExposureType, AdVRActionType, AdVREvent, AdPlayReportFailReason, AdVRPageId, AdReportMonitorType } from './types/ad-report-enum';

export type AdElement = Dom | null;
const isEvo = import.meta.env.EVO;

export class AdReporter {
  // 上报队列
  private static reportQueue: AdReportItem[] = [];
  // 上报定时器
  private static reportTimer: any = null;

  // VR上报
  public static vrReport(data: AdVrReportData) {
    if (!data?.event) {
      return;
    }
    if (!isEvo) {
      // 网页端走大同自动上报
      // @ts-ignore
      window.unReporter?.reportEvent({
        pgid: data.pgid,
        eventName: data.event,
        businessParams: Object.assign({}, data.params || {}, {
          pgid: data.pgid,
          eventName: data.event,
        }),
      });
      return;
    }
    if (!vnContext?.external?.reportVrEvent) {
      return;
    }
    vnContext.external.reportVrEvent(data.event, {
      pgid: data.pgid,
      eventName: data.event,
      eid: data.eid,
      ...data.params || {},
    });
  }

  public static vrEventReport(pgid: string, event: string, params: Record<string, string>) {
    this.vrReport({
      pgid,
      event,
      params,
    });
  }
  public static vrElementReport(pgid: string, eid: string, event: string, params: Record<string, string>) {
    this.vrReport({
      pgid,
      eid,
      event,
      params,
    });
  }
  // VR曝光上报
  public static vrExposureReport(
    eid: string,
    pgid: string,
    params: Record<string, string>,
    exposureType = AdExposureType.ORIGINAL,
  ) {
    let event = '';
    if (exposureType === AdExposureType.ORIGINAL) {
      event = AdVREvent.ORIGIN_EXPOSURE;
    } else if (exposureType === AdExposureType.EFFECTIVE) {
      event = AdVREvent.EFFECTIVE_EXPOSURE;
    }
    this.vrReport({
      pgid,
      eid,
      event: event as AdVREvent,
      params,
    });
  }

  // CGI点击上报
  public static cgiClickReport(data: AdClickReportData) {
    if (!data) {
      return;
    }
    if (data.items) {
      const { items } = data;
      const newItems = [];
      for (const item of items) {
        let { url } = item;
        if (data.actType) {
          // 替换acttype=XX
          // url = url.replace(/\bacttype=([^&]+)\b/, `acttype=${data.actType}`);
          url = url.replace('__ACT_TYPE__', `${data.actType}`);
        }
        newItems.push({
          url,
          delay: item.delay,
          callback: item.callback,
        });
      }
      console.log('[ad]cgiClickReport', data.logInfo, newItems.map(item => item.url));
      this.addReportQueue(newItems);
    }
    if (data.amsLink) {
      console.log('[ad]cgiClickReport-amsLink', data.logInfo);
      this.amsLinkReportClick(data);
    }
    // 进行第三方点击上报
    if (data.thirdItems) {
      console.log('[ad]cgiClickReport-thirdItems', data.logInfo, data.thirdItems.map(item => item.url));
      this.addReportQueue(data.thirdItems);
    }
  }

  // CGI曝光上报
  public static cgiExposureReport(
    data: AdCgiExposureData,
    exposureType = AdExposureType.ORIGINAL,
  ) {
    // 曝光上报链接
    let exposureReport: AdReportItem[] = [];
    if (exposureType === AdExposureType.ORIGINAL) {
      exposureReport = data.originReport || [];
    } else if (exposureType === AdExposureType.EFFECTIVE) {
      exposureReport = data.effectiveReport || [];
    } else {
      return;
    }
    console.log('[ad]cgiExposureReport', data.logInfo, exposureType, exposureReport.map(item => item.url));
    this.addReportQueue(exposureReport);
  }

  // AMS点击后链路上报
  public static amsLinkReportClick(data: AdClickReportData) {
    if (!data?.amsLink) {
      return;
    }
    const time_stamp = Date.now().toString();
    vn?.external?.setCommonInfo('amsLinkReportClick', time_stamp);
    try {
      const versionName = '';
      const {
        net_log_id,
        traceid = '',
        ...rest
      } = data.amsLinkParams || {};
      console.log('[ad]amsLinkReportClick', data.logInfo, net_log_id);
      request.post(
        'https://sdkreport.e.qq.com/link_event',
        {
          // ct: 1, // 联网类型 int，待确认前端能否获取,能获取到则上报
          os: 2, // 操作系统类型 int，win端值为2（安卓）
          av: versionName, // app_version，str，报pc终端版本
          // sv: '4.280.1150', // sdk_version，str，未接sdk不用报
          sdk_st: 7, // sdk类型，int，yyb写死为2（代表XQ），视频写死为 7（代表 XS）
          // wmpf_sdk_ver: 'xxx', // ⚠️ wmpf sdk的版本，新增需提至 report_server
          pkg: 'custom_define.qvideo.pc', // 应用包名，str，应用宝写死为"custom_define.yyb.pc"，视频写死为"custom_define.qvideo.pc"
          events: [
            {
              ts: time_stamp, // 毫秒时间戳，bigint，实时获取
              ei: 4000000, // 事件id，bigint，根据事件填
              biz: {
                ...rest,
                traceid: `${traceid}${net_log_id ? `NETLOG${net_log_id}` : ''}`,
                wx_sdk_type: 1, // WMPF SDK
                wx_sdk_ver: vn?.external?.getRemoteConfig('pc_wx_mini_game_sdk_version', ''),
              },
            },
          ],
        },
        {
          withCredentials: false,
          headers: {
            'user-agent': getAdUserAgent(),
          },
        },
      );
    } catch (e) {
      console.info('amsLinkReportClick error');
    }
  }

  public static addReportQueue(reportUrlList: AdReportItem[]) {
    this.reportQueue.push(...reportUrlList);

    // 执行一次上报
    this.doReport();

    // 判断当时上报定时器是否运行
    if (!this.reportTimer) {
      // 开启上报定时器
      this.startReportTimer();
    }
  }

  public static cgiExposureReportWithAdInfo(adInfo: AdInfo, exposureType = AdExposureType.ORIGINAL) {
    if (!adInfo) {
      return;
    }
    this.cgiExposureReport({
      logInfo: AdUtils.getAdPrintInfo(adInfo),
      originReport: adInfo.cgiOriginExposureReport,
      effectiveReport: adInfo.cgiEffectExposureReport,
    }, exposureType);
  }

  public static cgiClickReportWithAdInfo(
    adInfo: AdInfo,
    actType?: AdVRActionType,
    options = { reportClick: true, reportThird: true, reportAms: true },
  ) {
    if (!adInfo?.thirdClickReport) {
      return;
    }
    this.cgiClickReport({
      logInfo: AdUtils.getAdPrintInfo(adInfo),

      items: options.reportClick ? [
        {
          url: adInfo.clickUrl,
          delay: 0,
        },
      ] : null,
      thirdItems: options.reportThird ? adInfo.thirdClickReport : null,
      actType,
      amsLink: options.reportAms || false,
      amsLinkParams: adInfo.amsLinkParams,
    });
  }
  // 第三方点击上报
  public static thirdClickReportWithAdInfo(adInfo: AdInfo) {
    if (!adInfo?.thirdClickReport) {
      return;
    }
    console.log('[ad]thirdClickReportWithAdInfo', AdUtils.getAdPrintInfo(adInfo), adInfo.thirdClickReport.map(item => item.url));
    this.addReportQueue(adInfo.thirdClickReport);
  }
  public static amsLinkReportClickWithAdInfo(adInfo: AdInfo) {
    if (!adInfo) {
      return;
    }
    this.amsLinkReportClick({
      logInfo: AdUtils.getAdPrintInfo(adInfo),
      amsLink: true,
      amsLinkParams: adInfo.amsLinkParams,
    });
  }
  // 播放归因上报
  public static cgiPlayerReport(url: string, {
    playType,
    timeOffset = 0,
    failReason = AdPlayReportFailReason.NONE,
  }: IAdPlayReportData) {
    if (!url) {
      return;
    }
    const reportUrl = url
      .replace('__PLAY_TYPE__', `${playType}`)
      .replace('__TIMESTAMP__', `${Date.now()}`)
      .replace('__TIME_OFFSET__', `${timeOffset}`)
      .replace('__FAIL_REASON__', `${failReason}`);

    console.log('[ad]cgiPlayerReport', reportUrl);
    this.addReportQueue([{
      url: reportUrl,
      delay: 0,
    }]);
  }

  // 开启上报定时器
  private static startReportTimer() {
    if (this.reportTimer) {
      return;
    }

    this.reportTimer = setInterval(() => {
      // 判断上报队列
      if (this.reportQueue.length > 0) {
        // 进行上报
        this.doReport();
      } else {
        // 停止上报定时器
        this.stopReportTimer();
      }
    }, 1000);
  }
  // 停止上报定时器
  private static stopReportTimer() {
    if (!this.reportTimer) {
      return;
    }

    clearInterval(this.reportTimer);
    this.reportTimer = NaN;
  }
  // 进行上报
  private static doReport() {
    // 更新上报延迟时间
    this.reportQueue = this.reportQueue.filter((reportItem, _index) => {
      reportItem.delay = reportItem.delay || 0;
      if (reportItem.delay <= 0) {
        if (isEvo) {
          this.sendReport(reportItem);
        } else {
          this.sendReportForWeb(reportItem);
        }
        return false;
      }

      // 缩减上报延迟时间
      reportItem.delay -= 1000;
      return true;
    });
  }

  private static sendReport(item: AdReportItem) {
    const { url } = item;
    if (!url) return false;
    this.doReportMonitor(url, AdReportMonitorType.REQUEST_START, null);
    request
      .get(url, null, {
        withCredentials: true,
        headers: {
          'user-agent': getAdUserAgent(),
        },
      })
      .then((res: any) => {
        // console.log('[ad]report finish', url);
        if (item?.callback) { 
          item.callback(res);
          item.callback = null;
        }
        this.doReportMonitor(url, AdReportMonitorType.REQUEST_SUCCESS, null);
      })
      .catch((err: any) => {
        // console.log('[ad]report error', err);
        if (item?.callback) { 
          item.callback(null);
          item.callback = null;
        }
        this.doReportMonitor(url, AdReportMonitorType.REQUEST_ERROR, err);
      });
  }

  // Web端上报，使用image标签避免跨域问题
  private static sendReportForWeb(item: AdReportItem) {
    if (isEvo) {
      return;
    }
    const { url } = item;
    if (!url) return false;
    this.doReportMonitor(url, AdReportMonitorType.REQUEST_START, null);
    const img = new Image();
    img.onerror = () => {
      // 上报请求不会返回图片数据，所以这里会error, 实际请求200了
      this.doReportMonitor(url, AdReportMonitorType.REQUEST_SUCCESS, null);
    };
    img.src = url;
  }

  // 上报监听
  private static doReportMonitor(url: string, state: AdReportMonitorType, err: any) {
    if (!url) {
      return;
    }
    // {"enable":1,"upload_url":1,"upload_err":1}
    const reportMonitor = isEvo ? safeParseJson(vn.external.getRemoteConfig('pc_ad_report_monitor', '{}')) : {};
    if (!reportMonitor || parseInt(reportMonitor.enable) !== 1) {
      console.log('[ad]doReportMonitor-disable', state, url, err);
      return;
    }
    const domain = url.replace(/https:\/\/|http:\/\//, '').split('/')[0] || '';
    this.vrReport({
      pgid: AdVRPageId.AD_SPLASH, // 监控暂走闪屏页面ID
      event: AdVREvent.AD_TECH_PARAM_REPORT, // 走自定义上报字段，只落atta表
      params: {
        name: 'ad_report_monitor',
        business: 'ad',
        ad_reportkey_fst: '2',
        ad_reportkey_scd: '9',
        whole_ad_type: '0',

        type: String(state),
        domain,
        url: parseInt(reportMonitor.upload_url) === 1 ? url : '',
        error: parseInt(reportMonitor.upload_err) === 1 ? String(err) : '',
        vsite: '1',
      },
    });
    console.log('[ad]doReportMonitor', state, url, err);
  }
}
